export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/fitness_lessons.b20e397.svg";